import { colorConstants } from 'config/colorConstants';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const Calender = ({ stroke = colorConstants.violet }: { stroke?: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19 9H1M14 1V5M6 1V5M5.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21Z"
                    stroke={stroke}
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26 12.3333H2M19.3333 1.66663V6.99996M8.66667 1.66663V6.99996M8.4 28.3333H19.6C21.8402 28.3333 22.9603 28.3333 23.816 27.8973C24.5686 27.5138 25.1805 26.9019 25.564 26.1493C26 25.2936 26 24.1735 26 21.9333V10.7333C26 8.49308 26 7.37298 25.564 6.51733C25.1805 5.76468 24.5686 5.15276 23.816 4.76927C22.9603 4.33329 21.8402 4.33329 19.6 4.33329H8.4C6.15979 4.33329 5.03969 4.33329 4.18404 4.76927C3.43139 5.15276 2.81947 5.76468 2.43597 6.51733C2 7.37298 2 8.49308 2 10.7333V21.9333C2 24.1735 2 25.2936 2.43597 26.1493C2.81947 26.9019 3.43139 27.5138 4.18404 27.8973C5.03969 28.3333 6.15979 28.3333 8.4 28.3333Z"
                    stroke={stroke}
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13 6.66634H1M9.66667 1.33301V3.99967M4.33333 1.33301V3.99967M4.2 14.6663H9.8C10.9201 14.6663 11.4802 14.6663 11.908 14.4484C12.2843 14.2566 12.5903 13.9506 12.782 13.5743C13 13.1465 13 12.5864 13 11.4663V5.86634C13 4.74624 13 4.18618 12.782 3.75836C12.5903 3.38204 12.2843 3.07607 11.908 2.88433C11.4802 2.66634 10.9201 2.66634 9.8 2.66634H4.2C3.0799 2.66634 2.51984 2.66634 2.09202 2.88433C1.71569 3.07607 1.40973 3.38204 1.21799 3.75836C1 4.18618 1 4.74624 1 5.86634V11.4663C1 12.5864 1 13.1465 1.21799 13.5743C1.40973 13.9506 1.71569 14.2566 2.09202 14.4484C2.51984 14.6663 3.0799 14.6663 4.2 14.6663Z"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Calender;
